<template>
  <div class="reviewsCustomersBlock">
    <div class="reviewsCustomersBlock__items">
      <ClientOnly>
        <div
          v-for="item, i in reviewsData?.reviews"
          :key="`review_${i}`"
          class="reviewsCustomersBlock__item review"
        >
          <div class="review__heading">
            <span class="review__heading__date right text-[11px] grey-text text-lighten-1">{{ dateFormat(item.review_date) }}</span>
            <div class="review__heading__info star-list">
              <ul class="review__heading__rating star-list">
                <li
                  v-for="n in 5"
                  :key="`review_rating_${n}`"
                  class="sa-star"
                  :class="{active: n <= item.overall}"
                >
                </li>
              </ul>
              <span class="review__heading__name small">{{ item.display_name }}</span>
            </div>
          </div>
          <div class="review__message">
            <p class="small">
              {{ item.comments }}
            </p>
          </div>
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup>
const { getReviews } = useGeneral()

/**
* Props
*/
const props = defineProps({
  module: {
    type: [String],
    default: null
  },
  limit: {
    type: [Number],
    default: null
  }
})

/**
* Get Reviews
*/
const { data: reviewsData } = getReviews({
  limit: props.limit
})
</script>

<style lang="scss">
.reviewsCustomersBlock {
  &__items {
    padding: 0 .5rem;
  }
  .review {
    padding: 1.5rem 1.5rem .5rem 1.5rem;
    margin: 0 0 1rem 0;
    background-color: #f6f7f9;
    border-radius: 3px;

    &__heading {
      display: flex;
      flex-direction: row-reverse;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 1rem;
      &__info {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex: 1 1 auto;
      }
      &__rating {
        margin: 0 .5rem 0 0;
      }
      &__name {
        padding-top: 3px;
      }
      &__date {
        flex: 1 1 auto;
        padding-top: 3px;
        text-align: right;
      }
      .star-list {
        display: flex;
        align-items: center;
        .sa-star {
          display: block;
          width: 19px;
          height: 19px;
          margin-right: 2px;
          background: transparent url("/assets/general/img/sa-star-not-active.svg") 0 0 no-repeat;
          &.active {
            background: transparent url("/assets/general/img/sa-star.svg") 0 0 no-repeat;
          }
        }
      }
    }
  }
}

.grey {
  .review {
    background-color: #fff;
  }
}
</style>
